export class ThemesList{
	init() {
		const self = this;
		$(document).ready(function() {

        	let modal = $('#themesModal'),
    			isMobile = $(window).width() < 768 ? true : false;
    			modal.show().addClass('open')

    		if(modal.length){
        		let product = modal.find('.themes-list__product').get(0);
        		product.classList.add('active');

            	self.navigationControll(document.querySelector('.theme-modal__column-two'), true);
    		}else{
    			$('.themes-list__price-bullet').on('click', function(e) {
    				e.preventDefault();
    				localStorage.setItem('showChart', true);
					window.location = this.href;
    			})
    		}

        });

		$(document).on('click', '.themes-list__collapse-button', function(e, emulated) {
			e.stopPropagation();
			let $this = $(this),
				target = this.previousElementSibling,
				span = this.querySelector('span'),
                url = this.dataset.href,
                parent = this.closest('.themes-list__item'),
                isFetched = false;

			let collapses = $(target).closest('.themes-list__item').find('.themes-list__collapse');
			if(span.classList.contains('open') && !emulated){
				collapses.each(function() {
					let _this = $(this);
					_this.slideUp({
					  	start: function () {
							if(_this.hasClass('open') && !emulated){
								_this.removeClass('open')
								_this.next('.themes-list__collapse-button').find('span').removeClass('open');
							}else{
								_this.addClass('open');
							}
						}
					});
				})
			}else{
				$(target).slideDown({
				  	start: function () {
				    	$(this).css({
				    		display: "flex"
						})
					},
					complete: function() {
						if(target.classList.contains('open' && !emulated)){
							target.classList.remove('open')
						}else{
							target.classList.add('open');
						}
					}
				});
				span.classList.add('open');
				isFetched = true;
			}
			if(isFetched){
	            setTimeout(function(){
	                self.listChartAjax(url, parent);
	            }, 200);
			}
		})

		let items = document.querySelectorAll('.themes-list .themes-list__item');
		Array.prototype.forEach.call(items, function(el, i) {
			self.navigationControll(el, false);
			self.currentProductPriceFiller(el, el.querySelector('.themes-list__product.active'));
		});
	}
	navigationControll(elem, isModal){
		let self = this,
			$this = $(elem),
			productsSwitch = $this.find('.themes-list__select span').not('.select-label');

		productsSwitch.each(function() {
			this.addEventListener('click', function(){
				self.navigationSelectHandler(elem, this, isModal)
			});
		});
	}
	navigationSelectHandler(elem, button, isModal){
		let parent = elem,
			currentProduct = parent.querySelector('.themes-list__product.active'),
			newProduct = parent.querySelector('.themes-list__product[data-name="'+ button.dataset.name+'"]');

		this.selectHandler(button, isModal);
		this.currentProductSwitch(currentProduct, newProduct);
		if(isModal){
			document.querySelector('.themes-list__price-bullet.show-chart').dataset.href = button.dataset.href;
			document.querySelector('.features-list__header.performances').dataset.href = button.dataset.href;
			document.querySelector('.features-list__header.show-all').dataset.href = button.dataset.href;

			if(document.querySelector('.features-list__header.performances').classList.contains('active')){
				$('.features-list__header.performances').trigger('click', true);
			}
			this.currentProductDataSwitch(newProduct.dataset.id);
		}else{
			this.listChartAjax(button.dataset.href, elem);
			this.currentProductPriceFiller(parent, newProduct);
		}
		this.collapseOpener(currentProduct, newProduct);
	}
	selectHandler(button){
		let buttonSiblings = Array.prototype.filter.call(button.parentNode.children, function(child){
								return child !== button;
							});
		buttonSiblings.forEach(function(item) {
			item.classList.remove('active');
		})
		button.classList.add('active');
		button.closest('.themes-list__select').querySelector('button').innerText = button.dataset.name;
	}
	currentProductSwitch(currentProduct, newProduct){
		currentProduct.classList.remove('active');
		newProduct.classList.add('active');
	}
	currentProductPriceFiller(parent, product) {
		parent.querySelector('small span').innerText = product.dataset.date;
		parent.querySelector('.themes-list__price-bullet span').innerText = product.dataset.price;
	}
	currentProductDataSwitch(productId){
		let elements = document.querySelectorAll('.features-list--risks [data-product]');

		elements.forEach(function(item) {
			if(item.dataset.product == productId){
				item.classList.remove('d-none');
				item.classList.add('d-block');
			}else{
				item.classList.remove('d-block');
				item.classList.add('d-none');
			}
		})
	}
	collapseOpener (currentProduct, newProduct){
		if(currentProduct.querySelector('.themes-list__collapse.open')){
			newProduct.querySelector('.themes-list__collapse').classList = 'themes-list__collapse open';
		}
	}
	listChartAjax(url, parent){
		$.ajax({
            url: url,
            type: 'POST',
        }).success(function(res) {
        	let chart_container = parent.querySelector('.themes-list__product.active .themes-list__chart-container');
        	$(chart_container).html(res);
        })
    }
}